import {Helper} from "../util/helper.js";
import React from "react";

interface TimeSpanManagerProps {
    start: Date;
    end: Date;
    onFilterChange: (start: Date, end: Date, timeResolutionType: number) => void;
    onStartChange: (value: Date) => void;
    onEndChange: (value: Date) => void;
    last?: { start: Date, end: Date, timeResolutionType: number }

}

export default class TimeSpanManager extends React.Component<TimeSpanManagerProps, { selectedTimeSpan : string}>{
    private timeFrameTemplates: TimeSpanTemplate[] = [];
    private timeResolutionTypes = {
        "Hours": 0,
        "Days": 1,
        "Week": 2,
        "Month": 3
    }
    constructor(props) {
        super(props)
        this.state = {
            selectedTimeSpan: null
        }
        this.initApp();
    }

    private initApp = () => {
        const lastMonday = Helper.dates.getLastMonday();
        let today = new Date();
        today = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        const currentYear = today.getFullYear();
        const currentMonth = today.getMonth();
        const lastMonth = (currentMonth + 11) % 12;
        const nextMonth = (currentMonth + 13) % 12;
        this.timeFrameTemplates = [
            {
                text: Helper.getTranslation("Standard.Heute"),
                startDate: today,
                endDate: new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59),
                resolution: this.timeResolutionTypes.Hours,
                description: null,
                id: "today"
            },
            {
                text: Helper.getTranslation("WebSMS.Common.DateTime.LetzteWoche"),
                startDate: Helper.dates.addDays(lastMonday, -7),
                endDate: Helper.dates.addDays(lastMonday, -3),
                resolution: this.timeResolutionTypes.Hours,
                description: null,
                id: "lastWeek"
            },
            {
                text: Helper.getTranslation("WebSMS.ResourcePlanningScheduler.TimeSpanFilter.Templates.ThisWeek"),
                startDate: lastMonday,
                endDate: Helper.dates.addDays(lastMonday, 4),
                resolution: this.timeResolutionTypes.Hours,
                description: null,
                id: "thisWeek"
            },
            {
                text: Helper.getTranslation("WebSMS.Common.DateTime.NaechsteWoche"),
                startDate: Helper.dates.addDays(lastMonday, 7),
                endDate: Helper.dates.addDays(lastMonday, 11),
                resolution: this.timeResolutionTypes.Hours,
                description: null,
                id: "nextWeek"
            },
            {
                text: Helper.getTranslation("WebSMS.Common.DateTime.LetztenMonat"),
                startDate: new Date(currentYear - (currentMonth == 0 ? 1 : 0), lastMonth, 1),
                endDate: new Date(currentYear - (currentMonth == 0 ? 1 : 0), lastMonth + 1, 0),
                resolution: 1,
                description: null,
                id: "lastMonth"
            },
            {
                text: Helper.getTranslation("WebSMS.ResourcePlanningScheduler.TimeSpanFilter.Templates.ThisMonth"), 
                startDate: new Date(currentYear, currentMonth, 1),
                endDate: new Date(currentYear, currentMonth + 1, 0),
                resolution: 1,
                description: null,
                id: "thisMonth"
            },
            {
                text: Helper.getTranslation("WebSMS.Common.DateTime.NaechstenMonat"),
                startDate: new Date(currentYear + (currentMonth == 11 ? 1 : 0), nextMonth, 1),
                endDate: new Date(currentYear + (currentMonth == 11 ? 1 : 0), nextMonth + 1, 0),
                resolution: 1,
                description: null,
                id: "nextMonth"
            }
        ];
    }

    private mapToButton = (template: TimeSpanTemplate) => {
        const onClick = () => {
            this.setState({ selectedTimeSpan: template.id });
            this.props.onFilterChange(
                template.startDate,
                template.endDate,
                template.resolution
            )
        }
        return (
            <div key={template.id} className={"timespan_manager__dialog__action button " + (this.state.selectedTimeSpan == template.id ? "active" : "")} onClick={onClick} >
                {template.text}
            </div>
        );
    }

    render() {
        // let templates: TimeSpanTemplate[] = JSON.parse(JSON.stringify(this.timeFrameTemplates))
        // AP: stringify und parse haben in anderen Zeitzonen dafür gesorgt, dass die Datumswerte verschoben wurden (bspw. wurde 10.10. zum 09.10.), structuredClone erzeugt eine direkte Kopie
        let templates: TimeSpanTemplate[] = structuredClone(this.timeFrameTemplates);
        if (Helper.hasValue(this.props.last)) {
            templates = [
                ...templates.splice(0, 1),
                { startDate: this.props.last.start, endDate: this.props.last.end, id: "last", resolution: this.props.last.timeResolutionType, description: "", text: Helper.getTranslation("Einsatz.MultipleCreation.Position.Last") },
                ...templates
            ]
        }
        const span = {
            start: this.props.start,
            end: this.props.end
        };
        return (
            <>
                <style>
                    {".k-calendar .k-calendar-view .k-today .k-calendar-cell-inner, .k-calendar .k-calendar-view .k-today .k-link {box-shadow: none}"}
                    {".k-calendar .k-link:has(> .active_cell){border-radius: 0; padding-inline: 0; padding-block: 0}"}
                    {".timespan_manager__dialog__calendar__cell{width: 100%;height: 100%; display: flex;justify-content: center; align-items: center}"}
                </style>
                <div style={{ display: "flex", height: "315px" }} >
                    <div style={{ padding: "0 10px 0 0", height: "100%", overflowY: "auto" }} >
                        <div className={"timespan_manager__dialog__action " + (Helper.isNullOrEmpty(this.state.selectedTimeSpan) ? "active" : "")} title={"Custom"} onClick={() => { }}>
                            {Helper.getTranslation("Einsatz.MultipleCreation.Repetition.Custom")}
                        </div>
                        {templates.map(this.mapToButton)}
                    </div>
                    <div style={{ margin: "0 5px" }} >
                        <Calender
                            onChange={this.props.onStartChange}
                            value={this.props.start}
                            timeSpan={span}
                            weekNumber={true}
                        />
                    </div>
                    <div style={{ margin: "0 5px" }} >
                        <Calender
                            onChange={this.props.onEndChange}
                            value={this.props.end}
                            timeSpan={span}
                            weekNumber={true}
                        />
                    </div>

                </div>
                <TimeSpanTextBox start={this.props.start} end={this.props.end} onChange={({ start, end }) => {
                    this.props.onStartChange(start)
                    this.props.onEndChange(end)
                    this.setState({ selectedTimeSpan: null });
                }} />
            </>
        );
    }
}

interface TimeSpanTemplate {
    resolution: number;
    startDate: Date;
    endDate: Date;
    text: string;
    description: string;
    id: string;
}

interface CalenderProps {
    value: Date;
    onChange: (value: Date) => void;
    timeSpan?: {
        start: Date,
        end: Date
    },
    weekNumber: boolean;
}

class Calender extends React.Component<CalenderProps, { value: number }>{
    private divRef: HTMLDivElement;
    private calendar: kendo.ui.Calendar;
    constructor(props: CalenderProps) {
        super(props)
        this.state = {
            value: new Date(props.value).getTime()
        }
    }

    componentDidUpdate() {
        const value = new Date(this.props.value);
        if (value.getTime() != this.state.value) {
            this.calendar.value(value)
            this.setState({
                value: value.getTime(),
            })
        }

        this.calendar.setOptions({
            month: {
                content: this.getTemplate(),
                weekNumber: '<div style="font-style: italic;">#= data.weekNumber #</div>'
            },
        });
    }

    private getTemplate = () => {
        if (this.props.timeSpan) {
            let tmp = new Date(this.props.value);
            const value = new Date(tmp.getFullYear(), tmp.getMonth(), tmp.getDate()).getTime();
            const start = new Date(this.props.timeSpan.start).getTime();
            tmp = new Date(this.props.timeSpan.end);
            const end = new Date(tmp.getFullYear(), tmp.getMonth(), tmp.getDate()).getTime();

            return `#
                let style = '';
                let additionalClass = '';
                const value = data.date.getTime();
                if(${start} <= value && value <= ${end}){
                    additionalClass = 'active_cell';
                    let color = 'var(--main-menu-active-color)';
                    let backgroundColor = 'var(--main-menu-inactive-bg-color)';
                    if(${value} == value){
                        color = 'white';
                        backgroundColor = 'var(--primary-color)';
                    }
                    style = 'background-color: ' + backgroundColor + '; color: ' + color;
                }
            #
            <div class='timespan_manager__dialog__calendar__cell #=additionalClass#' style='#=style#'>
                #= data.value #
            </div>`
        }
        return "<div class='timespan_manager__dialog__calendar__cell'>#= data.value #</div>"
    }

    componentDidMount() {
        this.calendar = $(this.divRef).kendoCalendar({
            value: new Date(this.props.value),
            change: (ev) => {
                const value = new Date(this.calendar.value())
                this.setState({ value: value.getTime() }, () => {
                    this.props.onChange(value)
                })
            },
            weekNumber: this.props.weekNumber,
            month: {
                content: this.getTemplate(),
                weekNumber: '<div style="font-style: italic;">#= data.weekNumber #</div>'
            },
            footer: false
        }).data('kendoCalendar');

    }

    render() {
        return <div ref={(ref) => { this.divRef = ref }} ></div>
    }
}

interface TimeSpanTextBoxProps {
    start: Date;
    end: Date;
    onChange: (model: { start: Date, end: Date }) => void;
}

class TimeSpanTextBox extends React.Component<TimeSpanTextBoxProps, { editMode: boolean }>{
    private divRef: HTMLDivElement;
    constructor(props) {
        super(props)
        this.state = {
            editMode: false
        }
    }

    private formatString = (value: Date, showYear: boolean) => {
        return kendo.toString(new Date(value), "ddd. dd. MMMM" + (showYear ? ". yyyy" : ""))
    }

    private activateEditMode = () => {
        this.setState({ editMode: true }, () => {
            const el = this.divRef.childNodes[0] as HTMLElement;
            const input = el.childNodes[0] as HTMLInputElement;
            input.focus();

            const onFocusLost = () => {
                input.removeEventListener('blur', onFocusLost)
                this.setState({ editMode: false })
            }

            input.addEventListener('blur', onFocusLost)
        })
    }

    render() {
        return (<>
            <div style={{ padding: "16px 0", borderBottom: "1px solid #dee2e6", display: "flex", justifyContent: "center", color: "#212529", height: "72px", alignItems: "center" }}>
                <label style={{ cursor: "pointer", display: this.state.editMode ? "none" : "block" }} onClick={this.activateEditMode}>
                    {(Helper.dates.dateDiffInDays(this.props.start, this.props.end) == 0 ? "" : this.formatString(this.props.start, false) + " - ") + this.formatString(this.props.end, true) + " (" + (Helper.dates.dateDiffInDays(this.props.start, this.props.end) + 1).toString() + " " + Helper.getTranslation("CustomerPortal.Dashboard.Days") + ")"}
                </label>
                <div style={{ display: this.state.editMode ? "block" : "none" }} ref={(ref) => { this.divRef = ref }} >
                    <MaskedTextBox start={this.props.start} end={this.props.end} onChange={this.props.onChange} />
                </div>
            </div>
        </>);
    }
}

class MaskedTextBox extends React.Component<TimeSpanTextBoxProps, any>{
    private htmlRef: HTMLElement;
    private maskedTextBox: kendo.ui.MaskedTextBox;
    private validationDateFormat: string;
    private dateFormat: string;
    private maskFormat: string;
    constructor(props: TimeSpanTextBoxProps) {
        super(props)
        
        const trenner = kendo.culture().calendar["/"]
            .replace(".", "\\.")
            .replace(",", "\\,");
        
        this.validationDateFormat = "MM/DD/YYYY".replaceAll("/", trenner);
        this.dateFormat = "MM/dd/yyyy".replaceAll("/", trenner);
        this.maskFormat = "00/00/0000".replaceAll("/", trenner);
    }

    private isValid = (value: string) => {
        return moment(value, this.validationDateFormat, true).isValid()
    }

    private format = (value: Date) => {
        return kendo.toString(new Date(value), this.dateFormat);
    }


    componentDidUpdate() {
        const value = `${this.format(this.props.start)} - ${this.format(this.props.end)}`;
        if (this.maskedTextBox.value() != value) {
            this.maskedTextBox.value(value)
        }
    }

    componentDidMount() {
        const mask = this.maskFormat + " - " + this.maskFormat;
        this.maskedTextBox = $(this.htmlRef).kendoMaskedTextBox({
            mask: mask,
            change: (ev) => {
                const value = ev.sender.element.val() as string;
                let [start, end] = value.split(' - ')
                if (!this.isValid(start)) {
                    start = this.format(this.props.start)
                }
                if (!this.isValid(end)) {
                    end = this.format(this.props.end)
                }
                this.maskedTextBox.value(start + " - " + end);

                this.props.onChange({ start: moment(start, this.validationDateFormat).toDate(), end: moment(end, this.validationDateFormat).toDate() })
            },
            value: `${this.format(this.props.start)} - ${this.format(this.props.end)}`

        }).data('kendoMaskedTextBox');
    }



    render() {
        return <input ref={(ref) => { this.htmlRef = ref }} ></input>
    }
}